import { Choice } from "@/types";

/** 利用者状況の検索条件選択肢 */
export const StatusList: Choice[] = [
  { value: 1, text: "現在有効" },
  { value: 2, text: "中断" },
  { value: 4, text: "終了" },
  { value: 3, text: "中断・終了" }
];
